module.exports = __webpack_public_path__ + "static/media/position.2a1e2461.vert";